"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kiloFormatter = void 0;
// It's better to not localize 'en-US', because otherwise it would need to implement kiloFormatter manually
var _Intl$NumberFormat = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }),
  format = _Intl$NumberFormat.format;
var kiloFormatter = exports.kiloFormatter = format;